import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './locales'
import { useUserStore } from '@/stores/user'
import { initChatwoot } from '@/utils/chatwoot'

// Стили — design-system tokens first, then legacy utilities
import './design-system/index.css'
import './assets/main.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)

// КРИТИЧЕСКОЕ ИСПРАВЛЕНИЕ: Инициализируем userStore при запуске приложения
const userStore = useUserStore()
userStore.init()

initChatwoot()

app.mount('#app') 